import { NavLink, Outlet } from 'react-router-dom'
import { useAuth } from '../identity/AuthProvider'
import { BrandLockup } from '../../components/Brand'

export function AppLayout() {
  const { signOut } = useAuth()

  return (
    <div className="workspace-shell">
      <aside className="workspace-sidebar">
        <NavLink className="workspace-brand" to="/app"><BrandLockup compact /></NavLink>
        <nav aria-label="Navegação do sistema">
          <NavLink end to="/app">Visão geral</NavLink>
          <NavLink to="/app/contacts">Contatos</NavLink>
          <NavLink to="/app/catalog">Catálogo</NavLink>
          <NavLink to="/app/components">Componentes</NavLink>
          <NavLink to="/app/quotes">Orçamentos</NavLink>
          <NavLink to="/app/billing">Assinatura</NavLink>
        </nav>
        <button className="workspace-signout" onClick={() => void signOut()}>Sair</button>
      </aside>
      <div className="workspace-main">
        <Outlet />
      </div>
    </div>
  )
}
